import mockData from './mockGraphql/mockQueries';
import graphqlData from './graphqlData';
require('dotenv').config();

const useLocalData = process.env.VUE_APP_DATA_SOURCE_LOCAL === 'TRUE';

export const appData = useLocalData ? mockData : graphqlData;
